import React, { useEffect, useState } from 'react';
import styles from '../styles/termsOfUse.module.scss';
import { collection, getDocs } from "firebase/firestore";
import { db } from '../config/firebase';

function TermsOfUseEn() {
    const [termsOfUse, setTermsOfUse] = useState(null);

    useEffect(() => {
        fetchPost();
    }, []);

    const fetchPost = async () => {
        try {
            const usersCollectionRef = collection(db, "Contracts");
            const querySnapshot = await getDocs(usersCollectionRef);
            const doc = querySnapshot.docs.find(x => x.id === 'Terms Of Use En Version 2');
            if (doc) {
                setTermsOfUse(doc.data());
            }
        } catch (e) {
            console.error('Hata:', e);
        }
    };

    /**
     * \c etiketlerini algılayıp satırı ortalar (text-align: center).
     * \bs ... \bf etiketlerini algılayıp arasındakileri bold (<strong>) yapar.
     * \n karakterlerini alt satırlara böler.
     * Kontrol etiketlerini (\c, \bs, \bf, \b, \n) ekrandan temizler.
     */
    const renderFormattedContent = (rawText) => {
        if (!rawText) return null;

        // String olarak gelebilecek kaçışlı "\\n" ifadelerini gerçek satır sonuna çevir
        const normalizedText = rawText.replace(/\\n/g, '\n');
        const lines = normalizedText.split('\n');

        return lines.map((line, lineIndex) => {
            const trimmedLine = line.trim();

            // Boş satırsa dikey boşluk ver
            if (!trimmedLine) {
                return <div key={`spacer-${lineIndex}`} style={{ height: '14px' }} />;
            }

            // Satırda \c varsa ortala
            const isCentered = /\\c/.test(trimmedLine);

            // \c etiketini metinden temizle
            const cleanFromC = trimmedLine.replace(/\\c/g, '');

            // \bs ... \bf arasını yakalayarak ayır
            const parts = cleanFromC.split(/\\bs([\s\S]*?)\\bf/gi);

            return (
                <div
                    key={`line-${lineIndex}`}
                    className={styles.containerContent__text1}
                    style={{
                        textAlign: isCentered ? 'center' : 'left',
                        margin: '0 0 8px 0',
                        lineHeight: '1.65',
                        wordBreak: 'break-word'
                    }}
                >
                    {parts.map((part, partIndex) => {
                        const isBold = partIndex % 2 === 1;

                        // Kalan tekil kontrol karakterlerini temizle
                        const cleanText = part
                            .replace(/\\bs/g, '')
                            .replace(/\\bf/g, '')
                            .replace(/\\b/g, '');

                        if (!cleanText) return null;

                        if (isBold) {
                            return (
                                <strong
                                    key={`bold-${partIndex}`}
                                    style={{
                                        fontWeight: '800',
                                        color: '#111827',
                                        display: 'inline'
                                    }}
                                >
                                    {cleanText}
                                </strong>
                            );
                        }

                        return <span key={`text-${partIndex}`}>{cleanText}</span>;
                    })}
                </div>
            );
        });
    };

    return (
        <div>
            <div className={styles.header}>
                <div className={styles.header__content}>
                    <div>
                        <span className={styles.logo}>Ham Yap</span>
                    </div>
                </div>
            </div>

            <div className={styles.frame}>
                <div className={styles.containerContent}>
                    {termsOfUse && renderFormattedContent(termsOfUse.content)}
                </div>
            </div>
        </div>
    );
}

export default TermsOfUseEn;